import { Typography } from '@mui/material';

const EmptyState = ({ children }: { children: string }) => (
  <Typography variant="body2" color="text.secondary" sx={{ padding: 3, textAlign: 'center' }}>
    {children}
  </Typography>
);

export default EmptyState;
